// extracted by mini-css-extract-plugin
export default {"photoContainer":"styles_photoContainer__F--bg","photo":"styles_photo__3LMIa","removePhoto":"styles_removePhoto__T4rYd","spin":"styles_spin__X-XCL"};